'use client';

import { ComponentPromoBannerProps } from '@/types/components';
import { pickBanner } from '@/utils/bannerTargeting';
import { cookieHelper, CookieHelper } from '@/utils/cookies';
import { usePathname } from 'next/navigation';
import * as React from 'react';
import { PromoBanner } from './PromoBanner';

const ONE_WEEK_IN_SECONDS = 7 * 24 * 60 * 60;

const cookieKey = (id: number) => `promoBanner ID #${id}`;

export function PromoBannerPicker({
  banners,
}: {
  banners: ComponentPromoBannerProps[];
}) {
  const pathname = usePathname();
  const ids = banners.map(banner => banner.id).join(',');

  const [dismissedIds, setDismissedIds] = React.useState<number[] | null>(null);

  React.useEffect(() => {
    const helper = new CookieHelper(document.cookie);
    setDismissedIds(
      ids
        .split(',')
        .filter(Boolean)
        .map(Number)
        .filter(id => !!helper.get(cookieKey(id)))
    );
  }, [ids]);

  if (!dismissedIds) return null;

  const banner = pickBanner(banners, pathname, dismissedIds);

  if (!banner) return null;

  const handleClose = () => {
    cookieHelper?.set(cookieKey(banner.id), 'true', {
      maxAge: ONE_WEEK_IN_SECONDS,
    });
    setDismissedIds([...dismissedIds, banner.id]);
  };

  return <PromoBanner {...banner} onClose={handleClose} />;
}
